import { Pill, Tooltip } from '@7shifts/sous-chef';
import { WhatsAppStatus as WhatsAppStatusType } from 'types';
import { __ } from 'i18n';

type Props = {
    status: WhatsAppStatusType;
    /** Previsão de desbloqueio — só existe quando o canal está RESTRITO */
    restrictedUntil?: string | null;
};

const WhatsAppStatus = ({ status, restrictedUntil }: Props) => {
    switch (status) {
        case 'CONNECTED':
            return (
                <Tooltip
                    overlay={__('channelsPage.statusConnectedTitle')}
                    theme="white"
                >
                    <span>
                        <Pill theme="success">
                            {__('channelsPage.statusConnected')}
                        </Pill>
                    </span>
                </Tooltip>
            );
        case 'DISCONNECTED':
            return (
                <Tooltip
                    header={__('channelsPage.statusDisconnectedTitle')}
                    overlay={__('channelsPage.statusDisconnectedDescription')}
                    theme="white"
                >
                    <span>
                        <Pill theme="danger">
                            {__('channelsPage.statusDisconnected')}
                        </Pill>
                    </span>
                </Tooltip>
            );
        case 'RESTRITO':
            return (
                <Tooltip
                    header={__('channelsPage.statusRestrictedTitle')}
                    overlay={
                        restrictedUntil
                            ? `${__('channelsPage.statusRestrictedDescription')} ${__(
                                  'channelsPage.statusRestrictedEstimate'
                              )} ${new Date(restrictedUntil).toLocaleDateString(
                                  'pt-BR'
                              )}`
                            : __('channelsPage.statusRestrictedDescription')
                    }
                    theme="white"
                >
                    <span>
                        <Pill theme="danger">
                            {__('channelsPage.statusRestricted')}
                        </Pill>
                    </span>
                </Tooltip>
            );
        case 'qrcode':
            return (
                <Tooltip
                    header={__('channelsPage.statusQRCodeTitle')}
                    overlay={__('channelsPage.statusQRCodeDescription')}
                    theme="white"
                >
                    <span>
                        <Pill theme="info">
                            {__('channelsPage.statusQRCode')}
                        </Pill>
                    </span>
                </Tooltip>
            );
        case 'OPENING':
            return (
                <Tooltip
                    header={__('channelsPage.statusOpeningTitle')}
                    overlay={__('channelsPage.statusOpeningDescription')}
                    theme="white"
                >
                    <span>
                        <Pill theme="info">
                            {__('channelsPage.statusOpening')}
                        </Pill>
                    </span>
                </Tooltip>
            );
        case 'TIMEOUT':
        case 'PAIRING':
            return (
                <Tooltip
                    header={__('channelsPage.statusTimeoutTitle')}
                    overlay={__('channelsPage.statusTimeoutDescription')}
                    theme="white"
                >
                    <span>
                        <Pill theme="danger">
                            {__('channelsPage.statusTimeout')}
                        </Pill>
                    </span>
                </Tooltip>
            );
        default: {
            // `never` mantém a checagem de exaustividade: incluir um status novo
            // no union sem tratá-lo aqui vira erro de compilação, em vez de cair
            // silenciosamente no texto cru. Em runtime o fallback ainda cobre
            // valores legados do banco que estejam fora do union.
            const untranslatedStatus: never = status;
            return (
                <span>
                    <Pill theme="info">{untranslatedStatus as string}</Pill>
                </span>
            );
        }
    }
};

export default WhatsAppStatus;
